import { motion } from "framer-motion";

const EASE = [0.2, 0.7, 0.2, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "", as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.7, delay, ease: EASE }} {...rest}>
      {children}
    </M>
  );
};

// Masked line-by-line headline reveal. The viewport observer sits on the unclipped wrapper
// (the clipped inner line never intersects), and variants propagate to each line.
const LINE = { hidden: { y: "105%" }, show: { y: "0%" } };
export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0, inView = false }) => (
  <motion.span className={className} initial="hidden"
    {...(inView ? { whileInView: "show", viewport: { once: true, amount: 0.2 } } : { animate: "show" })}>
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span className={`block ${Array.isArray(l) ? l[1] : lineClass}`} variants={LINE}
          transition={{ duration: 0.9, delay: delay + i * 0.09, ease: [0.7, 0, 0.2, 1] }}>
          {Array.isArray(l) ? l[0] : l}{" "}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

// Image that un-masks into view; observer sits on the unclipped wrapper
export const MaskImage = ({ src, alt, className = "", imgClass = "" }) => (
  <motion.div className={className} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.1 }}>
    <motion.div className="h-full w-full overflow-hidden"
      variants={{ hidden: { clipPath: "inset(12% 12% 12% 12%)" }, show: { clipPath: "inset(0% 0% 0% 0%)" } }}
      transition={{ duration: 1.1, ease: EASE }}>
      <motion.img src={src} alt={alt} loading="lazy" className={`h-full w-full object-cover ${imgClass}`}
        variants={{ hidden: { scale: 1.15 }, show: { scale: 1 } }} transition={{ duration: 1.4, ease: EASE }} />
    </motion.div>
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, intro, dark = false, className = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    {eyebrow && <Reveal><p className={`eyebrow mb-5 flex items-center gap-3 ${dark ? "text-[#D8B66A]" : "text-[#1769AA]"}`}><span className="h-px w-8 bg-current" />{eyebrow}</p></Reveal>}
    <h2 className={`font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight ${dark ? "text-white" : "text-[#102A43]"}`}>
      <MaskLines lines={Array.isArray(title) ? title : [title]} inView />
    </h2>
    {intro && <Reveal delay={0.15}><p className={`mt-6 text-base md:text-lg leading-relaxed ${dark ? "text-[#c3d0dd]" : "text-[#526579]"}`}>{intro}</p></Reveal>}
  </div>
);
